import { piniaPageBrand } from '@stores/usePageBrandStore';
import { createApp } from 'vue';
import Paginator from './Paginator.vue';

export const initPaginator = () => {
  if (!document.querySelector('#pagination')) {
    return;
  }

  createApp(Paginator)
    .use(piniaPageBrand)
    .mount('#pagination');
};
